import {
  AccordionButton as ChakraAccordionButton,
  AccordionButtonProps
} from '@chakra-ui/react';

export {
  Accordion,
  AccordionIcon,
  AccordionItem,
  AccordionPanel
} from '@chakra-ui/react';
export type {
  AccordionButtonProps,
  AccordionIconProps,
  AccordionItemProps,
  AccordionPanelProps,
  AccordionProps
} from '@chakra-ui/react';

export function AccordionButton(props: AccordionButtonProps): JSX.Element {
  return (
    <ChakraAccordionButton
      {...props}
      _before={{ border: 'none' }}
      _after={{ border: 'none' }}
      border="none"
    />
  );
}
